import React from "react";
import "./Bumpups.css";
import { Upload, MessageCircle, Video, Code } from "lucide-react";

export default function Bumpups() {
  return (
    <div className="bumpups">
      <h2>Do more with <span>bumpups.com</span></h2>
      <p>
        Process your videos to deliver insights across all industries. Ask questions,
        request summaries, analyses, and more with Bump-1.0.
      </p>

      <div className="card-grid">
        <div className="card"><Upload /> <h4>Local Videos</h4> <a href="#">Learn more →</a></div>
        <div className="card"><MessageCircle /> <h4>Video Chat</h4> <a href="#">Learn more →</a></div>
        <div className="card"><Video /> <h4>AI YouTube</h4> <a href="#">Learn more →</a></div>
        <div className="card"><Code /> <h4>API</h4> <a href="#">Learn more →</a></div>
      </div>
    </div>
  );
}
